import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const HangUp = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M16.835 11.259c-1.521-.5-3.147-.771-4.835-.771s-3.314.27-4.835.77v2.065a1 1 0 0 1-.755.97l-2.835.716a1 1 0 0 1-1.245-.97V10.36c0-.714.377-1.381 1.015-1.701a19.2 19.2 0 0 1 3.82-1.43A19.4 19.4 0 0 1 12 6.62c1.67 0 3.29.212 4.835.61 1.334.343 2.613.825 3.82 1.43.638.32 1.015.987 1.015 1.701v3.678a1 1 0 0 1-1.245.97l-2.835-.717a1 1 0 0 1-.755-.97z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.42 14.039a1.75 1.75 0 0 1-2.179 1.697l-2.835-.717a1.75 1.75 0 0 1-1.321-1.697v-1.51A14.7 14.7 0 0 0 12 11.238c-1.418 0-2.789.2-4.085.574v1.51c0 .802-.544 1.5-1.321 1.697l-2.835.717a1.75 1.75 0 0 1-2.18-1.697V10.36c0-.972.516-1.913 1.43-2.372a20 20 0 0 1 3.969-1.486A20 20 0 0 1 12 5.87a20 20 0 0 1 8.991 2.119c.914.459 1.429 1.4 1.429 2.372z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
